const React = require('react')
const { useHistory, useLocation } = require('react-router-dom')
const { Col, Row, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } = require('reactstrap')
const { TablePagination } = require('./pagination.table')
const { useResponsive, BREAKPOINTS } = require('@hooks')

require('@styles/components/table/footer.table.css')

const TableFooter = ({ limit, setLimit, page, setPage, totalPages }) => {
    const history = useHistory()
    const location = useLocation()
    const isMobile = useResponsive(BREAKPOINTS.small)

    return (
        <>
            <Row className='table-footer-row'>
                <Col className='d-flex align-items-center'>
                    <span className='dropdown-text'>Show rows: </span>
                    <UncontrolledDropdown className='ms-1'>
                        <DropdownToggle caret outline className='table-dropdown-toggle'>
                            {limit}
                        </DropdownToggle>
                        <DropdownMenu className='table-dropdown-menu'>
                            {[10, 25, 50, 100].map(value => (
                                <DropdownItem
                                    key={value}
                                    className={`table-dropdown-item${limit === value ? ' active' : ''}`}
                                    onClick={() => {
                                        setLimit(value)
                                        setPage(1)
                                        const params = new URLSearchParams(location.search)
                                        params.set('p', '1')
                                        params.set('ps', value.toString())
                                        history.push({
                                            pathname: location.pathname,
                                            search: params.toString()
                                        })
                                    }}
                                    active={limit === value}
                                >
                                    {limit === value && <i className='fas fa-check me-2' />}
                                    {value}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Col>
                {!isMobile && (
                    <Col className='d-flex justify-content-end'>
                        <TablePagination page={page} limit={limit} totalPages={totalPages} />
                    </Col>
                )}
            </Row>
            {isMobile && (
                <Row style={{ paddingBottom: '16px' }}>
                    <Col>
                        <TablePagination page={page} limit={limit} totalPages={totalPages} />
                    </Col>
                </Row>
            )}
        </>
    )
}

module.exports = { TableFooter }
